import axios from "./index";

const BASE_PATH = "/notifications";

import { WS_SERVER } from "../config/constant";

class NotificationsApi {
  static async getLatestNotifications() {
    try {
      const response = await axios.get(`${BASE_PATH}/`, {
        params: {
          limit: 5,
          ordering: "-created_at",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching notifications:", error);
      throw error;
    }
  }

  static async getAllNotifications(page = 1) {
    try {
      const response = await axios.get(`${BASE_PATH}/`, {
        params: {
          page,
          page_size: 10,
          ordering: "-created_at",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching all notifications:", error);
      throw error;
    }
  }

  static async getUnreadCount() {
    try {
      const response = await axios.get(`${BASE_PATH}/unread_count/`);
      return response.data;
    } catch (error) {
      console.error("Error fetching unread count:", error);
      throw error;
    }
  }

  static async markAsRead(id) {
    try {
      const response = await axios.post(`${BASE_PATH}/${id}/mark_read/`);
      return response.data;
    } catch (error) {
      console.error("Error marking notification as read:", error);
      throw error;
    }
  }

  static async markAllAsRead() {
    try {
      const response = await axios.post(`${BASE_PATH}/mark_all_read/`);
      return response.data;
    } catch (error) {
      console.error("Error marking all notifications as read:", error);
      throw error;
    }
  }

  // WebSocket setup
  static async setupWebSocket(onMessage) {
    try {
      // Obtener token de Clerk sin especificar template
      const token = await window.Clerk.session.getToken({
        audience: process.env.REACT_APP_CLERK_JWT_AUDIENCE,
      });

      if (!token) {
        console.error("🔴 No se pudo obtener el token de Clerk");
        return null;
      }

      const wsUrl = `${WS_SERVER}notifications/?token=${token}`;
      const socket = new WebSocket(wsUrl);

      // Resto del código igual...
      socket.onopen = () => {
        console.log("🟢 WebSocket conectado exitosamente");
      };

      socket.onmessage = (event) => {
        console.log("📩 Mensaje WebSocket recibido:", event.data);
        try {
          const data = JSON.parse(event.data);
          console.log("📦 Datos parseados:", data);

          if (data.type === "notification") {
            console.log("🔔 Notificación recibida:", data.notification);
            onMessage(data.notification);
          } else {
            console.log("📌 Otro tipo de mensaje:", data);
          }
        } catch (error) {
          console.error("❌ Error procesando mensaje WebSocket:", error);
        }
      };

      socket.onerror = (error) => {
        console.error("❌ Error en WebSocket:", error);
      };

      socket.onclose = (event) => {
        console.log("🔴 WebSocket desconectado:", event.code, event.reason);
        if (event.code !== 1000) {
          setTimeout(
            () => {
              console.log("🔄 Intentando reconectar WebSocket...");
              this.setupWebSocket(onMessage);
            },
            process.env.NODE_ENV === "production" ? 10000 : 5000
          );
        }
      };

      return socket;
    } catch (error) {
      console.error("❌ Error configurando WebSocket:", error);
      return null;
    }
  }
}

export default NotificationsApi;
